export default "__VITE_ASSET__B5NgMUSc__"